import React from 'react';
import Button from '../Button/Button';
import TopBarActions from '../TopBarActions/TopBarActions';
import styles from './StickyHeader.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'link';

interface StickyHeaderProps {
  actions?: React.ReactNode;
  actionsClassName?: string;
  backButtonClassName?: string;
  backLabel?: string;
  bottomContent?: React.ReactNode;
  cancelLabel?: string;
  className?: string;
  contentClassName?: string;
  contentMaxWidth?: React.CSSProperties['maxWidth'];
  disabled?: boolean;
  isSaving?: boolean;
  leftContent?: React.ReactNode;
  onBack?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
  saveButtonClassName?: string;
  saveLabel?: string;
  saveVariant?: ButtonVariant;
  savingLabel?: string;
  topBarClassName?: string;
}

const StickyHeader: React.FC<StickyHeaderProps> = ({
  actions,
  actionsClassName = '',
  backButtonClassName = '',
  backLabel = 'Voltar',
  bottomContent,
  cancelLabel = 'Cancelar',
  className = '',
  contentClassName = '',
  contentMaxWidth,
  disabled = false,
  isSaving = false,
  leftContent,
  onBack,
  onCancel,
  onSave,
  saveButtonClassName = '',
  saveLabel = 'Salvar',
  saveVariant = 'primary',
  savingLabel = 'Salvando...',
  topBarClassName = '',
}) => {
  const rootClasses = [styles.root, className].filter(Boolean).join(' ');
  const contentClasses = [styles.content, contentClassName].filter(Boolean).join(' ');
  const topBarClasses = [styles.topBar, topBarClassName].filter(Boolean).join(' ');
  const resolvedLeftContent = leftContent ?? (onBack ? (
    <Button
      variant="ghost"
      size="small"
      icon="arrow_back"
      className={[styles.backButton, backButtonClassName].filter(Boolean).join(' ')}
      onClick={onBack}
      type="button"
    >
      {backLabel}
    </Button>
  ) : null);
  const resolvedActions = actions ?? ((onCancel || onSave) ? (
    <TopBarActions className={[styles.actions, actionsClassName].filter(Boolean).join(' ')}>
      {onCancel && (
        <Button variant="ghost" size="small" onClick={onCancel} type="button">
          {cancelLabel}
        </Button>
      )}
      {onSave && (
        <Button
          variant={saveVariant}
          size="small"
          className={saveButtonClassName}
          onClick={onSave}
          type="button"
          disabled={disabled}
        >
          {isSaving ? savingLabel : saveLabel}
        </Button>
      )}
    </TopBarActions>
  ) : null);

  return (
    <div className={rootClasses}>
      <div className={contentClasses} style={contentMaxWidth ? { maxWidth: contentMaxWidth } : undefined}>
        <div className={topBarClasses}>
          {resolvedLeftContent}
          {resolvedActions}
        </div>
        {bottomContent}
      </div>
    </div>
  );
};

export default StickyHeader;